import React from 'react';
import { Button } from '@cokitchen/cokitchen-components';

const EditManagerFooter = ({
  onConfirm,
  loading,
  disabled
}: {
  loading: boolean;
  onConfirm: () => void;
  disabled: boolean;
}) => {
  return (
    <Button
      small
      color='primary'
      variant='block'
      className='mx-auto'
      loading={loading}
      onClick={onConfirm}
      disabled={disabled}>
      Confirm
    </Button>
  );
};

export default EditManagerFooter;
